import { capitalizeFirstLetter } from '../../helpers/Common';

export const getSortStateParams = sortState => {
  if (!Object.keys(sortState).length) {
    return {};
  }
  const [key] = Object.keys(sortState);
  const keyArray = key.split('.');
  return {
    OrderBy: keyArray.map(word => capitalizeFirstLetter(word)).join('.'),
    Direction: sortState[key].toUpperCase(),
  };
};
